import store from "./init/store.js";
import { getQueryVariable } from "./helpers/get-query-variable.js";

export function getStartingGameArea(userStatus: "newUser" | "returningUser") {
  //TODO: TAKE OUT
  //return "b5-records-screen";
  //return "b5-offline-battle-over";

  //DEV STUFF FIRST:
  if (getQueryVariable("dev")) {
    return "arena";
  }
  //END DEV STUFF

  //New Users MUST go through some form of Onboarding to get signed in.
  if (userStatus === "newUser") {
    return "b5-onboarding-screen";
  }

  //If you're already logged in, you can go to either arena (which is a lobby) or b5-home-screen
  if (userStatus === "returningUser") {
    //This flag is set by store.js immediately if we've received an INVITE flag in the URL.
    const isInvitedFromLink = store.getState().battle.isMultiplayerMode;
    return isInvitedFromLink ? "arena" : "b5-home-screen";
  }
}



// WEBPACK FOOTER //
// ./src/getStartingGameArea.js